import React, { useEffect } from "react";

export default function PageWrapper({ children, testId }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <div
      data-testid={testId || "page-wrapper"}
      className="min-h-screen bg-[#F8FAFC]"
    >
      {children}
    </div>
  );
}

export const PageHero = ({
  eyebrow,
  title,
  description,
  image,
  testId = "page-hero",
}) => (
  <section
    data-testid={testId}
    className="relative bg-navy text-white overflow-hidden"
  >
    {image ? (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/60" />
      </div>
    ) : null}
    <div className="absolute inset-0 bg-grid-navy opacity-30" />
    <div className="relative max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12 pt-36 pb-20 sm:pt-44 sm:pb-24 lg:pt-48 lg:pb-32">
      {eyebrow ? (
        <div className="text-[11px] uppercase tracking-[0.22em] text-gold">
          {eyebrow}
        </div>
      ) : null}
      <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.04] font-light tracking-tight max-w-4xl">
        {title}
      </h1>
      {description ? (
        <p className="mt-6 max-w-2xl text-base sm:text-lg text-white/75 leading-relaxed">
          {description}
        </p>
      ) : null}
    </div>
  </section>
);
